export default __webpack_public_path__ + "static/media/Efrei.3356b179.png";